import OmsDatalayer from './oms.datalayer';
import EndCustomerGateway from './end-customer-gateway.datalayer';

export default {
  ...OmsDatalayer,
  ...EndCustomerGateway,
};
